
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as login5LDn4C5OfTWBX5Mf0GdLAcoz7egSLefSVDPR9C7AMRUMeta } from "/app/apps/landing2-ui/pages/index/my/login.vue?macro=true";
import { default as profileVHSJJJ903F_1n9WOFs0zg8C8gnqA8OQyRANNBJe0u2gMeta } from "/app/apps/landing2-ui/pages/index/my/profile.vue?macro=true";
import { default as _91token_93SlGjz7xzHkVeSnQd_v0YN9KvodfO59wuevFIvdo_JfQMeta } from "/app/apps/landing2-ui/pages/index/my/progress/[token].vue?macro=true";
import { default as progress3xhrTQQd_XgZuOlaGBTdXiN_AoVvhTMpOj_0xvUpzRsMeta } from "/app/apps/landing2-ui/pages/index/my/progress.vue?macro=true";
import { default as select_45courseU1o_uN6ytFnAbX52xoYHIMTF2RfV3jGoZBibXI3hraUMeta } from "/app/apps/landing2-ui/pages/index/my/select-course.vue?macro=true";
import { default as _91locale_93vf8HPBGf4qDUbLg2iVirksqCimx3gIcZ04dPhX5LunIMeta } from "/app/apps/landing2-ui/pages/privacy-policy/[locale].vue?macro=true";
import { default as _91_91slug_93_93KmVKgF6oulrRceUut1SWboaajE_bd7yt_hkTW_g4_ZsMeta } from "/app/apps/landing2-ui/pages/course-details/[[slug]].vue?macro=true";
import { default as select_45courseplx4ZAYk2HDQfEolpN61tl0Weq33nBu3JK48rBxJL50Meta } from "/app/apps/landing2-ui/pages/index/select-course.vue?macro=true";
import { default as loginZo8J4RZwyLMc0iLAKz5RdmjdzGJeQJRtPUfQB05xG0oMeta } from "/app/apps/landing2-ui/pages/login.vue?macro=true";
import { default as indexDRXjub0f90_nuiQp6wLZoHovgy6CX541FWZ_An_muFIMeta } from "/app/apps/landing2-ui/pages/privacy-policy/index.vue?macro=true";
import { default as select_45coursedInT7GDPASXVyJ1nrijzRYkJYYIrAqmwjXAoGo0L31UMeta } from "/app/apps/landing2-ui/pages/select-course.vue?macro=true";
import { default as sign_45inQ207RPhDNzjfToyx4qw1tJpYOKgqLLDZkEf9PXtlOFAMeta } from "/app/apps/landing2-ui/pages/sign-in.vue?macro=true";
import { default as _91slug_93Hw3VLQKgpA0JRVyfcUVhjoOswl0qbrSu5EjgPfkc0aQMeta } from "/app/apps/landing2-ui/pages/index/[locale]/courses/[category]/[slug].vue?macro=true";
import { default as _91slug_93GdVHjicrK_NUhFOCsbR_MlDvUe3fy_FJ5RJjGAbtWaQMeta } from "/app/apps/landing2-ui/pages/index/[locale]/articles/[slug].vue?macro=true";
import { default as indexhqx5K1bWJ8H6aQaaCQG2ooPqicU7jpEvNLrF2Hno7doMeta } from "/app/apps/landing2-ui/pages/index/[locale]/courses/[category]/index.vue?macro=true";
import { default as _91slug_934t4ywALCoR9mry3EkZg0UNTwdOGXQB3O1diQUQgLIpkMeta } from "/app/apps/landing2-ui/pages/index/[locale]/events/[slug].vue?macro=true";
import { default as aboutz0EAyYRsd1fBxb04RrS3s3PHVwJ1Oeaf_aZDNIVKO8YMeta } from "/app/apps/landing2-ui/pages/index/[locale]/about.vue?macro=true";
import { default as indexyNWxuEIDtGri7BKoREEi_qW21b3N7k3sq1A5NzPlIdQMeta } from "/app/apps/landing2-ui/pages/index/[locale]/articles/index.vue?macro=true";
import { default as contactsLMsOmsouiNAk_unxZNg3SzNfxbtfM1kI71QOuz_XC4EMeta } from "/app/apps/landing2-ui/pages/index/[locale]/contacts.vue?macro=true";
import { default as indexoHPKBzmzIQHTfFWZ1w_To_uknB4GLOgz_MT6cGTQsjAMeta } from "/app/apps/landing2-ui/pages/index/[locale]/courses/index.vue?macro=true";
import { default as index4F2GDN_DfGsrCNKlb2cm1ifqfHVv2_T59_nYUTy_sV4Meta } from "/app/apps/landing2-ui/pages/index/[locale]/events/index.vue?macro=true";
import { default as privacy_45policyaltkrNXIHeaU4BU18z5xNly9bWhdAHhEm05nTkhFIJcMeta } from "/app/apps/landing2-ui/pages/index/[locale]/privacy-policy.vue?macro=true";
import { default as program_45details_TFmkqqZLOFtyABVbB7ljXeT7_Ld7zGsDbJFGlkZCg0Meta } from "/app/apps/landing2-ui/pages/index/[locale]/program-details.vue?macro=true";
import { default as select_45courseXrVdgGsMySfFi_ogNJadiuJQjhayihvGamw1VmG72K8Meta } from "/app/apps/landing2-ui/pages/index/[locale]/select-course.vue?macro=true";
import { default as termstGdQpK2lw8Qn8o1Jj9YRxY8iFxLizjLjiltpzWe9OooMeta } from "/app/apps/landing2-ui/pages/index/[locale]/terms.vue?macro=true";
import { default as indexM_vYmR4vrQMuWz5_Xd2GEfrqREEMdudAEpKcUb0P_nEMeta } from "/app/apps/landing2-ui/pages/index/[locale]/index.vue?macro=true";
import { default as indexycLVC89_XLPvaRPDyrG4RSc_Qn18K4Px47e9TDPqd1AMeta } from "/app/apps/landing2-ui/pages/index/index.vue?macro=true";
export default [
  {
    name: "index-my-login",
    path: "//my/login",
    meta: login5LDn4C5OfTWBX5Mf0GdLAcoz7egSLefSVDPR9C7AMRUMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/my/login.vue")
  },
  {
    name: "index-my-profile",
    path: "//my/profile",
    meta: profileVHSJJJ903F_1n9WOFs0zg8C8gnqA8OQyRANNBJe0u2gMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/my/profile.vue")
  },
  {
    name: "index-my-progress",
    path: "//my/progress",
    meta: progress3xhrTQQd_XgZuOlaGBTdXiN_AoVvhTMpOj_0xvUpzRsMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/my/progress.vue"),
    children: [
  {
    name: "index-my-progress-token",
    path: ":token()",
    meta: _91token_93SlGjz7xzHkVeSnQd_v0YN9KvodfO59wuevFIvdo_JfQMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/my/progress/[token].vue")
  }
]
  },
  {
    name: "index-my-select-course",
    path: "//my/select-course",
    meta: select_45courseU1o_uN6ytFnAbX52xoYHIMTF2RfV3jGoZBibXI3hraUMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/my/select-course.vue")
  },
  {
    name: "privacy-policy-locale",
    path: "/privacy-policy/:locale()",
    component: () => import("/app/apps/landing2-ui/pages/privacy-policy/[locale].vue")
  },
  {
    name: "course-details-slug",
    path: "/course-details/:slug?",
    meta: _91_91slug_93_93KmVKgF6oulrRceUut1SWboaajE_bd7yt_hkTW_g4_ZsMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/course-details/[[slug]].vue")
  },
  {
    name: "index-select-course",
    path: "//select-course",
    meta: select_45courseplx4ZAYk2HDQfEolpN61tl0Weq33nBu3JK48rBxJL50Meta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/select-course.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/app/apps/landing2-ui/pages/login.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/app/apps/landing2-ui/pages/privacy-policy/index.vue")
  },
  {
    name: "select-course",
    path: "/select-course",
    component: () => import("/app/apps/landing2-ui/pages/select-course.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: sign_45inQ207RPhDNzjfToyx4qw1tJpYOKgqLLDZkEf9PXtlOFAMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/sign-in.vue")
  },
  {
    name: "index-locale-courses-category-slug",
    path: "//:locale()/courses/:category()/:slug()",
    meta: _91slug_93Hw3VLQKgpA0JRVyfcUVhjoOswl0qbrSu5EjgPfkc0aQMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/[locale]/courses/[category]/[slug].vue")
  },
  {
    name: "index-locale-articles-slug",
    path: "//:locale()/articles/:slug()",
    meta: _91slug_93GdVHjicrK_NUhFOCsbR_MlDvUe3fy_FJ5RJjGAbtWaQMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/[locale]/articles/[slug].vue")
  },
  {
    name: "index-locale-courses-category",
    path: "//:locale()/courses/:category()",
    meta: indexhqx5K1bWJ8H6aQaaCQG2ooPqicU7jpEvNLrF2Hno7doMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/[locale]/courses/[category]/index.vue")
  },
  {
    name: "index-locale-events-slug",
    path: "//:locale()/events/:slug()",
    meta: _91slug_934t4ywALCoR9mry3EkZg0UNTwdOGXQB3O1diQUQgLIpkMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/[locale]/events/[slug].vue")
  },
  {
    name: "index-locale-about",
    path: "//:locale()/about",
    component: () => import("/app/apps/landing2-ui/pages/index/[locale]/about.vue")
  },
  {
    name: "index-locale-articles",
    path: "//:locale()/articles",
    meta: indexyNWxuEIDtGri7BKoREEi_qW21b3N7k3sq1A5NzPlIdQMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/[locale]/articles/index.vue")
  },
  {
    name: "index-locale-contacts",
    path: "//:locale()/contacts",
    meta: contactsLMsOmsouiNAk_unxZNg3SzNfxbtfM1kI71QOuz_XC4EMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/[locale]/contacts.vue")
  },
  {
    name: "index-locale-courses",
    path: "//:locale()/courses",
    component: () => import("/app/apps/landing2-ui/pages/index/[locale]/courses/index.vue")
  },
  {
    name: "index-locale-events",
    path: "//:locale()/events",
    meta: index4F2GDN_DfGsrCNKlb2cm1ifqfHVv2_T59_nYUTy_sV4Meta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/[locale]/events/index.vue")
  },
  {
    name: "index-locale-privacy-policy",
    path: "//:locale()/privacy-policy",
    meta: privacy_45policyaltkrNXIHeaU4BU18z5xNly9bWhdAHhEm05nTkhFIJcMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/[locale]/privacy-policy.vue")
  },
  {
    name: "index-locale-program-details",
    path: "//:locale()/program-details",
    meta: program_45details_TFmkqqZLOFtyABVbB7ljXeT7_Ld7zGsDbJFGlkZCg0Meta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/[locale]/program-details.vue")
  },
  {
    name: "index-locale-select-course",
    path: "//:locale()/select-course",
    component: () => import("/app/apps/landing2-ui/pages/index/[locale]/select-course.vue")
  },
  {
    name: "index-locale-terms",
    path: "//:locale()/terms",
    meta: termstGdQpK2lw8Qn8o1Jj9YRxY8iFxLizjLjiltpzWe9OooMeta || {},
    component: () => import("/app/apps/landing2-ui/pages/index/[locale]/terms.vue")
  },
  {
    name: "index-locale",
    path: "//:locale()",
    component: () => import("/app/apps/landing2-ui/pages/index/[locale]/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/apps/landing2-ui/pages/index/index.vue")
  }
]